module.exports = "/packs/step4-286414ad5f091cafcc35971b62e7a860.png";